import { ProfileTSInstance } from '@/store'

export const state = () => ({
  userTfa: ''
})

const mutations = {
  SET_USER (state, user) {
    state.userTfa = user
  }
}

const actions = {
  GET_USER_MFA (context) {
    return ProfileTSInstance.me.getUserMFA()
  },
  MFA_SEND (context) {
    return ProfileTSInstance.me.sendUserMFA()
  },
  MFA_DELETE (context, code) {
    return ProfileTSInstance.me.deleteUserMFA(code)
  }
}

export default {
  state,
  mutations,
  actions
}
